import styled from 'styled-components'
import { FieldSwitchToggle } from '@/components/form'
import { colors, fontSizes, fontWeights } from '@/styles'
import { SectionRow } from '../elements'

const Section = styled.div`
  ${props =>
    props.condensed
      ? `
    margin: 0;
    max-width: 400px;
  `
      : `max-width: 660px;
  margin-bottom: 30px;
  `}

  box-sizing: content-box;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const Title = styled.p`
  color: ${colors.regular};
  font-size: ${fontSizes.regular};
  font-weight: ${fontWeights.medium};
  line-height: 22px;
  margin: 0;
`

const Description = styled.p`
  color: ${colors.regular};
  font-size: ${fontSizes.small};
  line-height: 18px;
  margin: 0;
`

const ToggleDescriptionField = ({ condensed, title, description, fieldName }) => {
  return (
    <Section condensed={condensed} className="descriptionField">
      <Container>
        <SectionRow>
          <Title>{title}</Title>
          <FieldSwitchToggle name={fieldName} />
        </SectionRow>
        <Description>{description}</Description>
      </Container>
    </Section>
  )
}

export default ToggleDescriptionField
